import {Popup, SearchBy} from "../../IDMS/Interfaces/interfaces";
import {filterState, IUserData} from "../../IDMS/Interfaces/IUsers";
import {IHubAddEditModal} from "./IHubAddEditModal";
import {TenantLine} from "../../IDMS/Interfaces/ITenantSystem";
import {ReactElement} from "react";

export interface IUserManagement {
    Selected_Key: string,
    tenantSystem: TenantLine[],
    listOfSubscopes: string[],
    ShowIDFilter: boolean,
    IDFilter: string,

    Sort_Key: string,
    Sort_Reverse: boolean,
    filterState_oldTen: filterState[],
    filterBy: SearchBy,
    listOfScopes: string[],
    filterState: filterState,
    filterValueState: filterState,

    userData: UsersDic,
    Popup: Popup,

    AddEditModal: IHubAddEditModal,

    currentProject: string,
}

export interface UsersDic {
    [key: string]: IUserData,
}


// export interface TableHeaderCell {
//     name: string;
//     title?: string;
//     sortable?: boolean;
//     filter?: boolean;
//     check?: boolean;
// }

export enum UserManagementModalMode {
    Add,
    Edit,
    None
}

export interface IUserTableData {
    user: IUserData
    userId: string
    displayName: string
    authLevelGlobal: ReactElement
    authLevelGlobalLabel: string
    authLevelProjects: ReactElement[]
    authLevelProjectsLabel: string
    lastLogin: number
    lastLoginDate: string
    authLevel: string
    authLevelLabel?: string
}
